/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetAktTypesResponseItems,
    GetAktTypesResponseItemsFromJSON,
    GetAktTypesResponseItemsFromJSONTyped,
    GetAktTypesResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetAktTypesResponse
 */
export interface GetAktTypesResponse {
    /**
     * 
     * @type {Array<GetAktTypesResponseItems>}
     * @memberof GetAktTypesResponse
     */
    items: Array<GetAktTypesResponseItems>;
}

export function GetAktTypesResponseFromJSON(json: any): GetAktTypesResponse {
    return GetAktTypesResponseFromJSONTyped(json, false);
}

export function GetAktTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAktTypesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetAktTypesResponseItemsFromJSON)),
    };
}

export function GetAktTypesResponseToJSON(value?: GetAktTypesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(GetAktTypesResponseItemsToJSON)),
    };
}


